export default __webpack_public_path__ + "static/media/divider-coin.e5c82aef.svg";